import React, { Component, Fragment } from "react";
import * as PropTypes from "prop-types";
import { Avatar, Button, Col, Drawer, Form, Icon, Modal, Row, Spin, Tabs } from "antd";

import moment from "moment";

import { commentService } from "./../../redux/services";

import TabLikes from "./likes";
import TabReplies from "./replies";

const FormItem = Form.Item;

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			id       : 0,
			item     : {},
		};
	}

	fieldOptions = {
		id        : {
			label: "ID",
		},
		message   : {
			label: "Mensagem",
		},
		created_at: {
			label: "Criação",
		},
		updated_at: {
			label: "Última atualização",
		},
		user      : {
			label: "Usuário",
		},
	};

	onOpen = (id) => {
		this.setState({
			isLoading: true,
			id       : id,
			item     : {},
		});

		commentService.show({id})
		.then((response) => {
			this.setState({
				isLoading: false,
				item     : response.data.data,
			});
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	itemType = (val) => {
		if( val === "disease" )
		{
			return "Doença";
		}
		else if( val === "machine_implement" )
		{
			return "Máquinas/Implementos";
		}
		else if( val === "nutritional_deficiency" )
		{
			return "Deficiência nutricional";
		}
		else if( val === "pest" )
		{
			return "Praga";
		}
		else if( val === "variety" )
		{
			return "Variedade";
		}
		else if( val === "weed" )
		{
			return "Planta daninha";
		}
	};

	render() {
		const {visible}             = this.props;
		const {id, isLoading, item} = this.state;

		return (
			<Drawer
				visible={visible}
				className="drawer-form"
				width={600}
				maskClosable={false}
				closable={false}
				keyboard={false}
				placement="right"
				onClose={this.onClose}>
				<Form layout="vertical">
					<div className="form-header">
						<Button className="btn-close" onClick={this.onClose} icon="close" disabled={isLoading} />
						<div className="ant-drawer-title">{`Visualizar registro [${id}]`}</div>
					</div>
					{isLoading ? (
						<div className="text-center" style={{padding: 20}}>
							<Spin indicator={<Icon type="loading" style={{fontSize: 60}} spin />} />
						</div>
					) : (
						<div className="form-body">
							<FormItem label={this.fieldOptions.message.label}>
								{item.message}
							</FormItem>
							<Row gutter={16}>
								<Col xs={24} sm={12}>
									<FormItem label={this.fieldOptions.created_at.label}>
										{moment(item.created_at).calendar()}
									</FormItem>
								</Col>
								<Col xs={24} sm={12}>
									<FormItem label={this.fieldOptions.updated_at.label}>
										{moment(item.updated_at).calendar()}
									</FormItem>
								</Col>
							</Row>
							<FormItem label={this.fieldOptions.user.label}>
								{item.user && (
									<Row gutter={16}>
										<Col xs={24} sm={4}>
											<p>{item.user.avatar ? <Avatar size={64} src={item.user.avatar_sizes.admin_listing} /> : <Avatar size={64} icon="user" />}</p>
										</Col>
										<Col xs={24} sm={20}>
											{item.user.name}<br />
											<b>Celular:</b> {item.user.customer.cellphone}<br />
											<b>E-mail:</b> {item.user.email}<br />
											<b>Atividade:</b> {item.user.customer.activity.name}
										</Col>
									</Row>
								)}
							</FormItem>
							{item.parent && (
								<Fragment>
									<h3>Foi uma resposta para o comentário</h3>
									<FormItem label={this.fieldOptions.message.label}>
										{item.parent.message}
									</FormItem>
									<Row gutter={16}>
										<Col xs={24} sm={12}>
											<FormItem label={this.fieldOptions.created_at.label}>
												{moment(item.parent.created_at).calendar()}
											</FormItem>
										</Col>
										<Col xs={24} sm={12}>
											<FormItem label={this.fieldOptions.updated_at.label}>
												{moment(item.parent.updated_at).calendar()}
											</FormItem>
										</Col>
									</Row>
									<FormItem label={this.fieldOptions.user.label}>
										{item.parent.user && (
											<Row gutter={16}>
												<Col xs={24} sm={4}>
													<p>{item.parent.user.avatar ? <Avatar size={64} src={item.parent.user.avatar_sizes.admin_listing} /> : <Avatar size={64} icon="user" />}</p>
												</Col>
												<Col xs={24} sm={20}>
													{item.parent.user.name}<br />
													<b>Celular:</b> {item.parent.user.customer.cellphone}<br />
													<b>E-mail:</b> {item.parent.user.email}
												</Col>
											</Row>
										)}
									</FormItem>
								</Fragment>
							)}
							<h3>Informações do item comentado</h3>
							{item.item && (
								<div>
									{item.item.name}<br />
									<b>Tipo:</b> {this.itemType(item.comment_type)}<br />
									<b>ID:</b> {item.comment_id}<br />
									{item.item.culture && (
										<Fragment>
											<b>Cultura:</b> {item.item.culture.name}<br />
										</Fragment>
									)}
									<b>Ativo:</b> {item.item.is_active ? "Sim" : "Não"}<br />
								</div>
							)}
							<br />
							<Tabs defaultActiveKey="likes" style={{marginBottom: 24}}>
								<Tabs.TabPane tab={`Curtidas (${item.likes_count})`} key="likes">
									<TabLikes items={item.likes ? item.likes : []} />
								</Tabs.TabPane>
								{!item.parent_id && <Tabs.TabPane tab={`Respostas (${item.replies_count})`} key="replies">
									<TabReplies items={item.replies ? item.replies : []} />
								</Tabs.TabPane>}
							</Tabs>
						</div>
					)}
				</Form>
			</Drawer>
		)
	}
}

export default Show;
